module.exports = __webpack_public_path__ + "fonts/poppins-semibold.bafbc0b1.ttf";